import Page from 'components/modules/public/pages/WorkerPolicy';
export default Page;